import {
  Container,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  useColorModeValue,
} from '@chakra-ui/react';
import Card from 'components/card/Card';

interface ErrorStateProps {
  title: string;
  message: string;
}

const ErrorState = ({ title, message }: ErrorStateProps) => {
  const bgColor = useColorModeValue('white', 'gray.800');

  return (
    <Container maxW="container.lg" py={10}>
      <Card bg={bgColor} p={8}>
        <Alert
          status="error"
          variant="subtle"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          minH="200px"
          borderRadius="md"
        >
          <AlertIcon boxSize="40px" mr={0} />
          <AlertTitle mt={4} mb={1} fontSize="lg">
            {title}
          </AlertTitle>
          <AlertDescription maxWidth="sm" fontSize="md">
            {message}
          </AlertDescription>
        </Alert>
      </Card>
    </Container>
  );
};

export default ErrorState;
